module.exports = __webpack_public_path__ + "img-3322d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/client/auth/modals/register/register-bg.jpg
// module id = 1353
// module chunks = 0